export enum StatusEnum {
    DRAFT = 1,
    SCHEDULED = 2,
    PUBLISHED = 3,
    RETRACTED = 4,
    FAILED = 5,
    MODERATED = 6,
    INREVIEW = 7,
    FAILED_REVIEW = 8,
}
